import { cn } from '@/lib/utils';

interface CompetencyBarProps {
  importance: number;
  className?: string;
}

export default function CompetencyBar({ importance, className }: CompetencyBarProps) {
  const widthPct = Math.max(0, Math.min(100, importance * 100));
  return (
    <span className={cn('block h-1 rounded-full bg-muted overflow-hidden', className)}>
      <span
        className="block h-full bg-slate-400/70"
        style={{ width: `${widthPct}%` }}
      />
    </span>
  );
}
